import { CommonModule } from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {IndexIoService} from '../../services/index-io.service';
import {DocumentsDTO} from '../../models/dto/document-dto';

@Component({
  selector: 'bnpp-indx-about',
  imports: [CommonModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  standalone: true,
})
export class AboutComponent implements OnInit{
  private indexInfoService = inject(IndexIoService);
  public deployUrlHost = this.indexInfoService.getDeployUrlHost();
  documentsForHandBookAndIOSCOInfo = this.indexInfoService.documentsForHandBookAndIOSCOInfo;

  ngOnInit(): void {
    this.indexInfoService.getDocumentsForHandBookAndIOSCO();
  }

  onDownloadDocument(item: DocumentsDTO) {
    this.indexInfoService.downloadDocument("Document",item.Path,item.Title,item.FileExtension,item.S3Key).subscribe();
  }
}
